import React from "react";

const CallToActionBanner = () => {
  return (
    <section className="bg-accent text-white py-12 px-6">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* CTA Text */}
        <div className="text-center md:text-left">
          <h2 className="text-2xl md:text-3xl font-bold">
            Ready to Upgrade Your IT Infrastructure?
          </h2>
          <p className="mt-2 text-white/90 text-sm md:text-base">
            Partner with us for secure, scalable, and future-ready network solutions.
          </p>
        </div>

        {/* CTA Button */}
        <div>
          <a
            href="/contact"
            className="inline-block bg-white text-accent font-semibold px-6 py-3 rounded-lg shadow hover:bg-gray-100 transition"
          >
            Request a Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default CallToActionBanner;
